import { TmApiClientError } from '@/core/error/transport/tmApiClientError'
import type { Optional } from '@/types'
import type { TmTransportHttpErrorCode } from '@/core/error/transport/types'

interface TmApiAccessErrorData {
  code: 403
  message: string
  status?: 'personal-use' | 'closed-acc' | 'closed-subacc'
  emailOrLogin?: string
  fullName?: string
  availableToResendAt?: string
}

export class TmApiAccessError extends TmApiClientError<TmApiAccessErrorData> {
  public name = 'TmApiAccessError'

  protected override code: TmTransportHttpErrorCode = 403

  private get errorData() {
    return this.data.data || {}
  }

  public getLoginOrEmail(): Optional<string> {
    return this.errorData.emailOrLogin
  }

  public getFullName(): Optional<string> {
    return this.errorData.fullName
  }

  public getAvailableToResendAt() {
    return this.errorData.availableToResendAt
  }

  public shouldBeMonitored(): boolean {
    return false
  }
}
